module.exports = __webpack_public_path__ + "static/media/pristine.a2050abb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/pristine.mp3
// module id = 1347
// module chunks = 0